<template>
  <footer app-footer>
    <a></a>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [app-footer]{ .wh(100%,114); background:rgba(0,0,0,0.7);
      a{.block;  .wh(650, 100%); .contain("@{mob}/footer.png"); .mh-c;}
    }
  }
  .pc{
    [app-footer]{.wh(100%,78px);  background:#000000; .fix;.b(0);  z-index: 100;
      a{.block;  .wh(650px,35px); .contain("@{pc}/footer.png"); .mh-c; .mt(10px);}
    }

    @media screen and (max-width: @screen-xxl-min){
      [app-footer]{.h(56px);
        a{.mt(4px);}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue